/**
 *
 * ResumeControlPresens
 *
 */

import React, { memo, useCallback, useEffect } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { List, Empty, Button } from "antd";

// icons
import CustomIcons from "components/CustomIcons";

// utils
import {
  getExcusedAbsencesByStudent,
  generateAbsenceReason,
  // new
  getExcusedStudents,
} from "utils/helpers/helper.generateData";
import { getUniqueArrayObj, getObjId } from "utils/helpers/helper.general";
import { convertTimeToString, convertDateToWeekDay, convertDateToString } from "utils/moment/moment.utils";

function ResumeControlPresens({
  // states
  formData,
  course,
  absences,
  attendances,
  currentStep,
  controlType,
  // actoins
  prevStep,
  nextStep,
  goToStep,
  result,
  // default props
  className,
}) {
  const childClassNames = classNames("resume-control-presens", className);
  const { t } = useTranslation();

  useEffect(() => {
    if (formData?.missing_students) {
      
      const excused = getExcusedStudents(formData?.missing_students, absences, attendances);
      let excusedUnique = getUniqueArrayObj(excused, "_id");
      excusedUnique = excusedUnique?.sort((a, b) =>
        a?.description?.lastname.localeCompare(b?.description?.lastname),
      );
    }
  }, [formData?.missing_students, course, absences]);

  const goToPrev = () => {
    if (controlType == "all") {
      !!goToStep && goToStep(1);
    } else {
      !!prevStep && prevStep();
    }
  };

  const onConfirm = () => {
    result();
    !!nextStep && nextStep();
  };

  const stdReason = useCallback(absData => generateAbsenceReason(absData), []);

  const itemAbsTimeRange = useCallback(element => { 
    return (
      <div className="absence-wrapper-date">

        <div className="absence-date__row">
          <div className="column helper">{t("common.from")}</div>
          <div className="column day">{!!element?.date_from && convertDateToWeekDay(element?.date_from, "dd")}{' '}</div>
          <div className="column">
            {!!element?.date_from && convertDateToString(element?.date_from)}
          </div>
          <div className="column time">
            {!!element?.time_from && convertTimeToString(element?.time_from)}
            {(!!!element?.date_to && !!!element?.recurring_date && !!element?.time_to) && (
              ' - '+ convertTimeToString(element?.time_to)
            )}
          </div>
        </div>
        {(!!element?.date_to || !!element?.recurring_date) && (
          <div className="absence-date__row">
            <div className="column helper">{t("common.to")}</div>
            <div className="column day">
              {!!element?.recurring_date
                ? convertDateToWeekDay(element?.recurring_date, "dd")
                : (
                  !!element?.date_to
                  ? convertDateToWeekDay(element?.date_to, "dd")
                  : convertDateToWeekDay(element?.date_from, "dd")
                )}{' '}
            </div>
            <div className="column">
              {!!element?.recurring_date
                ? convertDateToString(element?.recurring_date)
                : (
                  !!element?.date_to
                  ? convertDateToString(element?.date_to)
                  : convertDateToString(element?.date_from)
                )}
            </div>
            <div className="column time">
              {!!element?.time_to ? convertTimeToString(element?.time_to) : convertTimeToString(element?.time_from)}
            </div>
          </div>
        )}
        
        {/* {absenceDuration && (
          <div className="absence-date__row">
            <div className="column helper big">{t("absences.duration")}:</div>
            <div className="column">
              <span className="absence-time">{absenceDuration}</span>
            </div>
          </div>
        )} */}
      </div>
    );
  }, []);

  
  const renderItem = useCallback(
    item => {
      let abs = null;
      const absArr = getExcusedAbsencesByStudent(
        formData?.missing_students,
        absences,
      );
      const currentAbs = absArr?.filter(abs => getObjId(item) == getObjId(abs?.student));
      
      const hasSickness = currentAbs?.filter(absence => absence?.status == "sick") || [];

      abs = !!item?.hasAbs && item?.hasAbs?.[0] || currentAbs?.length > 0 && currentAbs?.[0];
      if (hasSickness?.length > 0) {
        abs = hasSickness?.[0];
      }
  
      const reason = stdReason(abs);
      return !!item && (
        <List.Item key={item?._id + "-excused-resume"}>
          <CustomIcons type="person" />
          <List.Item.Meta
            title={`${item?.description?.lastname} ${
              item?.description?.firstname
            }`}
            description={
              <>
                {reason}
                {!!abs && itemAbsTimeRange(abs)}
              </>
            }
          />
        </List.Item>
      );
    },
    [formData?.missing_students, absences],
  );


  return (
    <div className={childClassNames}>
      <List
        className="list-absence-student"
        dataSource={formData?.missing_students || []}
        renderItem={renderItem}
        locale={{
          emptyText: <Empty description={t("attendances.noAbsentInList")} />,
        }}
      />
      <div className="control-actions-wrapper">
        <Button className="btn-previous" onClick={goToPrev}>
          {t("common.backTo")}
        </Button>
        <Button className="confirm-btn" onClick={onConfirm}>
          {t("common.confirm")}
        </Button>
      </div>
    </div>
  );
}

ResumeControlPresens.defaultProps = {};

export default memo(ResumeControlPresens);
